export default __webpack_public_path__ + "static/media/rishabh-singh.4c9f559d.png";